<div class="filters-container">
  <div class="filter-type">
    <span (click)="toggleFilterMenu()">
      <app-etx-icons name="filter"></app-etx-icons
      ><span class="badge filter-badge" *ngIf="(nbSelectFilters$ | async) > 0">{{ nbSelectFilters$ | async }}</span>
    </span>
    <span class="separator"></span>
  </div>
</div>
